export enum FILE_TYPES {
    'GIF' = '.gif',
    'JPG' = '.jpg',
    'PNG' = '.png',
    'PDF' = '.pdf',
}

export const FILE_TYPES_ARRAY = Object.keys(FILE_TYPES).map((label) => ({
    label,
    value: FILE_TYPES[label as keyof typeof FILE_TYPES],
}));

export const ABSOLUTE_MAX_FILE_SIZE = 20;

/**
 * Defines the available Lumapps Component types.
 */
export enum LumappsComponentType {
    AskAnswer = 'ai_augmented_search',
    FileList = 'file_list',
    Uploader = 'uploader',
    Iframe = 'iframe',
}
